import { render } from "./ProductList.vue?vue&type=template&id=51f90b70&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=51f90b70&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f90b70"],['__file',"src/views/h5/common/product/info/ProductList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51f90b70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51f90b70', __exports__)) {
    api.reload('51f90b70', __exports__)
  }
  
  module.hot.accept("./ProductList.vue?vue&type=template&id=51f90b70&scoped=true", () => {
    api.rerender('51f90b70', render)
  })

}


export default __exports__